import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <h3>The page you are looking for is not available</h3>
        </div>
    );
};

export default NotFound;